import React from 'react';
import { ServerDataGridConfig } from '@warehouse/shared/ui';
import { NxObjectSearchableFields } from '@warehouse/object-browser/core';
import { SortModelAdapter } from '../core/sort-model.adapter';
import { FilterModelAdapter } from '../core/filter-model.adapter';
import { ObjectBrowserPaginationNavigator } from './ObjectBrowserPaginationNavigator';

function ObjectBrowserPagination() {
	return <ObjectBrowserPaginationNavigator centered />;
}

export const objectBrowserGridConfig: ServerDataGridConfig<NxObjectSearchableFields> = {
	sorting: { adapter: SortModelAdapter },
	filtering: { adapter: FilterModelAdapter },
	pinning: 'store',
	reorder: true,
	resizable: true,
	pagination: { placement: 'in-grid', component: ObjectBrowserPagination },
};
